/**
 * HS 부·류 정적 매핑 (3-panel layout 의 정적 데이터).
 *
 * Sources:
 *  - SECTION_NAMES: WCO HS 21 부 한글명 (HeadingBreadcrumb.jsx 의 매핑과 1:1 동일)
 *  - SECTION_TO_CHAPTERS: 부 → 그 부의 chapter 배열 (chapter 77 reserved 제외)
 *
 * 변경 시 책임: HeadingBreadcrumb.SECTION_NAMES + 이 파일 + backend hs_section_map.py
 *  (3 곳 동기화 — WCO HS 표준 변경 드뭄, 5년에 1번)
 */

export const SECTION_NAMES = {
  1: "산 동물·동물성생산품",
  2: "식물성생산품",
  3: "동·식물성 지방·기름",
  4: "조제식료품·음료·주류·식초·담배",
  5: "광물성생산품",
  6: "화학공업생산품",
  7: "플라스틱·고무",
  8: "원피·가죽·모피",
  9: "목재·코르크·조물재료",
  10: "펄프·종이·서적·신문",
  11: "방직용 섬유와 그 제품",
  12: "신발·모자·우산·지팡이",
  13: "석·도자·유리",
  14: "천연·양식진주·귀석·반귀석·귀금속",
  15: "비금속과 그 제품",
  16: "기계류·전기기기",
  17: "수송기기",
  18: "광학·정밀기기·시계·악기",
  19: "무기",
  20: "잡품",
  21: "예술품·수집품·골동품",
};

export const SECTION_TO_CHAPTERS = {
  1: ["01", "02", "03", "04", "05"],
  2: ["06", "07", "08", "09", "10", "11", "12", "13", "14"],
  3: ["15"],
  4: ["16", "17", "18", "19", "20", "21", "22", "23", "24"],
  5: ["25", "26", "27"],
  6: ["28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38"],
  7: ["39", "40"],
  8: ["41", "42", "43"],
  9: ["44", "45", "46"],
  10: ["47", "48", "49"],
  11: [
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "60",
    "61",
    "62",
    "63",
  ],
  12: ["64", "65", "66", "67"],
  13: ["68", "69", "70"],
  14: ["71"],
  15: ["72", "73", "74", "75", "76", "78", "79", "80", "81", "82", "83"], // 77 reserved skipped
  16: ["84", "85"],
  17: ["86", "87", "88", "89"],
  18: ["90", "91", "92"],
  19: ["93"],
  20: ["94", "95", "96"],
  21: ["97"],
};

export const ALL_SECTION_IDS = Array.from({ length: 21 }, (_, i) => i + 1);

// reverse index: chapter (string) → section id (int)
const _CHAPTER_TO_SECTION = (() => {
  const m = new Map();
  for (const [sec, chapters] of Object.entries(SECTION_TO_CHAPTERS)) {
    for (const ch of chapters) {
      m.set(ch, Number(sec));
    }
  }
  return m;
})();

/**
 * 부 id (1~21) → chapter 배열.
 * @returns {string[] | null}
 */
export function chaptersBySectionId(sectionId) {
  if (sectionId === null || sectionId === undefined) return null;
  const n = Number(sectionId);
  if (!Number.isInteger(n) || n < 1 || n > 21) return null;
  return SECTION_TO_CHAPTERS[n] ?? null;
}

/**
 * chapter (string 또는 int) → 부 id.
 * @returns {number | null}
 */
export function sectionIdOfChapter(chapter) {
  if (chapter === null || chapter === undefined) return null;
  const padded = String(chapter).padStart(2, "0");
  return _CHAPTER_TO_SECTION.get(padded) ?? null;
}
